module.exports = __webpack_public_path__ + "img/weather03.e20f9d71.png";